import Header from "../.shared/header/header";
import Footer from "../.shared/footer/footer";
import ArticleCard from "./ArticleCard";
import styles from "./Articles.module.css";

import CEOWeekly from '../../assets/CEO-Weekly.png';
import BodyNetwork from '../../assets/Body-Network.png';
import SingleCare from '../../assets/SingleCare.png';
import LAWire from '../../assets/la-wire.png';
import DailyMail from '../../assets/daily-mail.png';
import IBD from '../../assets/ibd-logo.svg';
import Valiant from '../../assets/valiant-ceo.png';
import HealthcareIT from '../../assets/healthcare-it-today.png';
import BritishBulletin from '../../assets/british-bulletin.jpeg';
import MedicalNewsToday from '../../assets/MedicalNewsToday.png';
import AuthorityMagazine from '../../assets/Authority-Magazine.webp';
import boderline from "../../assets/boderline.png"

export default function ArticlesPage() {

    const articles = [
        {
            imgSrc: AuthorityMagazine,
            publisher: "Authority Magazine",
            title: "Paul Moss and Antoni Adamrovich Of Tb2.Health On What You Need To Know Before You Consider Taking Weight Loss Drugs",
            url: "https://medium.com/authority-magazine/paul-moss-and-antoni-adamrovich-of-tb2-health-49f6d473922c"
        },
        {
            imgSrc: MedicalNewsToday,
            publisher: "Medical News Today",
            title: "Ozempic: How semaglutide drugs can help with long-term weight loss - Medical News Today",
            url: "https://www.medicalnewstoday.com/articles/how-semaglutide-drugs-such-as-ozempic-can-help-with-long-term-weight-loss-and-heart-health"
        },
        {
            imgSrc: DailyMail,
            publisher: "Daily Mail",
            title: "More than 100 US deaths linked to Ozempic and similar drugs",
            url: "https://www.dailymail.co.uk/health/article-13276757/deaths-linked-ozempic-weight-loss-drugs-analysis.html"
        }, {
            imgSrc: CEOWeekly,
            publisher: "CEO Weekly",
            title: "Meet Paul Moss, CEO and Co-founder of TB2.Health",
            url: "https://ceoweekly.com/meet-paul-moss-ceo-and-co-founder-of-tb2-health/"
        },
        {
            imgSrc: BodyNetwork,
            publisher: "Body Network",
            title: "15 Foods You Should Always Avoid, According to Experts",
            url: "https://bodynetwork.com/nutrition-15-unhealthy-foods-to-avoid-expert-advice/"
        },
        {
            imgSrc: BodyNetwork,
            publisher: "Body Network",
            title: "12 Tips to Maintain Weight Loss After Using Ozempic and GLP-1 Medications",
            url: "https://bodynetwork.com/weight-loss-maintenance-tips-after-ozempic/"
        },
        {
            imgSrc: SingleCare,
            publisher: "Single Care",
            title: "Ozempic diet: What to eat for weight loss",
            url: "https://www.singlecare.com/blog/ozempic-diet/"
        },
        {
            imgSrc: LAWire,
            publisher: "LA Wire",
            title: "TB2.Health Founders’ Story on Health-Centric Weight Loss",
            url: "https://lawire.com/semaglutides-changed-my-life-the-tb2-health-founders-story-on-creating-a-health-centric-weight-loss-solution/"
        },
        {
            imgSrc: IBD,
            publisher: "Investors Business Daily",
            title: "Why Wall Street Got Even More Excited About The Glucose Monitor — And How Dexcom, Abbott Labs Stand To Benefit",
            url: "https://www.investors.com/news/technology/dexcom-dxcm-stock-abbott-abt-continuous-glucose-monitor-cgm/"
        },
        {
            imgSrc: Valiant,
            publisher: "Valiant CEO",
            title: "From Overweight to Overcoming: Paul Moss’s Journey to Health and Entrepreneurship",
            url: "https://valiantceo.com/paul-moss-tb2-health/"
        },
        {
            imgSrc: HealthcareIT,
            publisher: "Healthcare IT Today",
            title: "Lean Digital: Behavior Change for Weight and Obesity",
            url: "https://www.healthcareittoday.com/2024/05/01/lean-digital-behavior-change-for-weight-and-obesity/"
        }
    ];

    return (
        <>
            <div className={styles.articlesPageContainer}>
                <Header />
                <div className={styles.bannerSection}> 
                    <div className={styles.bannerText}>
                        <h1 className={styles.title}>Articles</h1>
                        <span className={styles.subtitle}>
                            Curated insights from trusted, top-tier publications.
                        </span>
                    </div>
                </div>
                <div className={styles.articlesSection}>
                    {articles.map((article, index) => (
                        <ArticleCard 
                            key={index}
                            imgSrc={article.imgSrc}
                            publisher={article.publisher}
                            title={article.title}
                            url={article.url}
                        />
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
}